import React, { useContext } from 'react'
import { Grid } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { FormattedMessage } from 'react-intl'
import styles from '../../../styles'
import { WHITE } from '../../../theme'
import { ResponsiveContext } from '../../../utils/context/ResponsiveContext'
import linksEnum from '../../../enums/linksEnum'
import { useLocation } from 'react-router'

const useStyles = makeStyles<{ isLargeScreen: boolean, pathname: string }>()(
	(theme, { isLargeScreen, pathname }) => ({
		...styles(theme),
		pointsInteretsContainer: {
			position: 'relative',
			zIndex: 2
		},
		titreContainer: {
			paddingBottom: 69,
			background: WHITE,
			borderRadius: '0px 0px 30px 30px'
		},
		titre: {
			margin: 0,
			marginLeft: 30,
			marginRight: 30,
			...styles(theme).text4,
			fontSize: isLargeScreen ? 35 : pathname.includes(linksEnum.OFFRE) ? 20 : 22,
			lineHeight: isLargeScreen ? '45px' : '32px',
			textAlign: 'center'
		}
	})
)

interface AcceptingProps {
	alentoorApiKey: string,
	longitude: string,
	latitude: string
}

type PointsInteretsProps = AcceptingProps

const PointsInterets: React.FC<PointsInteretsProps> = (
	{
		alentoorApiKey,
		longitude,
		latitude
	}
) => {
	const { isLargeScreen } = useContext(ResponsiveContext)
	const location = useLocation()
	const { classes } = useStyles({ isLargeScreen, pathname: location.pathname })

	return (
		<Grid container item xs={12} className={classes.pointsInteretsContainer}>
			<Grid container item xs={12} justifyContent="center" className={classes.titreContainer}>
				{
					<h2 className={classes.titre}>
						<FormattedMessage
							id="residence.pointsInterets.titre"
							defaultMessage="Découvrez les <span>points d'intérêts</span> du quartier"
							description="Titre des points d'intérêt"
							values={{
								span: (chunk) => <span className={classes.colorAccessibility}>{chunk}</span>
							}}
						/>
					</h2>
				}
			</Grid>

			<div style={{ width: '100%', aspectRatio: isLargeScreen ? '1440/687' : '428/687', marginTop: -30, zIndex: 2 }} className="alentoor-widget" data-config={`{
				"key": "${alentoorApiKey}",
				"latitude": "${latitude || 43.52267}",
				"longitude": "${longitude || 5.44961}",
				"zoom": 16
			}`}></div>
		</Grid>
	)
}

export default PointsInterets
